import React from 'react'

const ClientInfoOtherView = ({other, clientInfo: client, aimAndRelationshipFeatures}) => {
  if (!client) {
    return null;
  }
  return (
    <div>
      {other && client.rejectionReason && !client.active && <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="#">Основание для запрета обслуживания</label>
            <div className="form-element-data">
              <div className="form-element-data-text">
                <p>{client.rejectionReason}</p>
              </div>
            </div>
          </div>
        </div>
      </div>}
      {other && client.hearAbout && <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="#">Откуда узнали о нас</label>
            <div className="form-element-data">
              <div className="form-element-data-text">
                <p>{client.hearAbout}</p>
              </div>
            </div>
          </div>
        </div>
      </div>}
      {other && client.hearAbout && client.hearAbout === "Другое" && <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="#">Источник</label>
            <div className="form-element-data">
              <div className="form-element-data-text">
                <p>{client.hearSource}</p>
              </div>
            </div>
          </div>
        </div>
      </div>}
      { aimAndRelationshipFeatures && other && client.aimAndRelationship && <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="#">
              Цели установления и характер отношений с ООО «ВИСЕМ»
            </label>
            <div className="form-element-data">
              <div className="form-element-data-text">
                <p>{client.aimAndRelationship}</p>
              </div>
            </div>
          </div>
        </div>
      </div>}
      {!other && client.description && <div className="form-row">
        <div className="form-row-item">
          <div className="form-element">
            <label className="form-element-label" htmlFor="#">Дополнительное описание</label>
            <div className="form-element-data">
              <p>{client.description}</p>
            </div>
          </div>
        </div>
      </div>}
    </div>
  )
}

export default ClientInfoOtherView
